import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Footer from '../components/Footer/Footer';
import Pagetop from '../components/Pagetop/Pagetop';
import Allvideogallery from '../components/Allvideogallery/Allvideogallery';

class Videospage extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar title="Our videos" />
                <Pagetop title="Our videos" />
                <Allvideogallery/>
                <Footer/>
            </div>
        );
    }
}

export default Videospage;